import {LoadableView} from '../../../state/views/types';
import {getWorkspaceDisplayName} from '../../../state/workspaces/namedWorkspaceActionsInternal';
import {compareDates} from '../../../state/workspaces/sort';
import {NW_DEFAULT_ID} from '../../../state/workspaces/types';
import {ViewWithNamedWorkspaceId} from '../../../state/workspaces/workspaceViewListSelector';
import {NamedWorkspaceMenuItem} from '../types';

/**
 * Returns the viewer's drafts that are not associated with a published workspace.
 */
export function getMenuItems(
  optionType: 'shared' | 'personal',
  workspaces: Array<ViewWithNamedWorkspaceId<LoadableView>>,
  viewerUsername: string | undefined
) {
  const workspaceViewOptions: NamedWorkspaceMenuItem[] = [];

  if (workspaces == null || workspaces.length === 0) {
    return [];
  }

  workspaces.forEach(view => {
    workspaceViewOptions.push({
      optionType,
      displayName: getWorkspaceDisplayName(view),
      namedWorkspaceId: view.namedWorkspaceId,
      viewCid: view.cid,
      createdAt: view.createdAt,
      createdBy: view.user,
      updatedAt: view.updatedAt,
      updatedBy: view.updatedBy,
      photoUrl: view.user.photoUrl,
      username: view.user.username,
      isDefault: view.namedWorkspaceId.id === NW_DEFAULT_ID,
    });
  });

  const sortedItems =
    optionType === 'personal'
      ? sortPersonalWorkspaces(workspaceViewOptions, viewerUsername)
      : sortSharedWorkspaces(workspaceViewOptions);
  return sortedItems.filter(item => item !== undefined);
}

// Pushes the default view to top of list,
// then sorts by creation timestamp
const sortSharedWorkspaces = (options: NamedWorkspaceMenuItem[]) => [
  ...options.filter(opt => opt.isDefault),
  ...options
    .filter(opt => !opt.isDefault)
    .sort((a, b) =>
      compareDates(new Date(a.createdAt ?? ''), new Date(b.createdAt ?? ''))
    ),
];

// Pushes the viewer's personal workspace to top of list,
// then sorts alphabetically
const sortPersonalWorkspaces = (
  options: NamedWorkspaceMenuItem[],
  viewerUsername: string | undefined
) => [
  ...options.filter(opt => opt.username === viewerUsername),
  ...options
    .filter(opt => opt.username !== viewerUsername)
    .sort((a, b) =>
      a.displayName
        .toLocaleUpperCase()
        .localeCompare(b.displayName.toLocaleUpperCase())
    ),
];
